export const buildProjectUrl = (project) =>
  `/projects/${project.slug}/${project.uuid}`;
